/**
 * analytics.js — เชื่อมต่อ Google Analytics 4 (gtag.js) สำหรับเว็บแอดมิน
 *
 * เพิ่มเมื่อ 2026-07-19 ตาม TOR ข้อ 2.21 "พัฒนาระบบเก็บสถิติการใช้งาน"
 *
 * ต้องตั้งค่า REACT_APP_GA_MEASUREMENT_ID ใน .env / .env.production ก่อนถึงจะทำงาน
 * (ดูวิธีสร้างใน "คู่มือตั้งค่า Firebase + Google Analytics")
 * ถ้ายังไม่ได้ตั้งค่า ฟังก์ชันทั้งหมดจะ no-op เงียบ ๆ ไม่กระทบการทำงานของเว็บ
 *
 * ไม่ใส่ script tag แบบ static ใน public/index.html เพราะไม่อยาก hardcode
 * measurement ID ลงไฟล์ HTML ตรง ๆ — โหลด gtag.js แบบ dynamic ตอน runtime แทน
 * เพื่อให้ตั้งค่าผ่าน .env ได้เหมือน config ตัวอื่นในโปรเจกต์ (เช่น REACT_APP_SERVER_URL)
 */

const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID

let initialized = false

export function initGA() {
  if (initialized || !MEASUREMENT_ID) return
  initialized = true

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`
  document.head.appendChild(script)

  window.dataLayer = window.dataLayer || []
  function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments)
  }
  window.gtag = gtag
  gtag('js', new Date())
  // send_page_view: false เพราะเราจะยิง page_view เองตอนเปลี่ยน route (SPA)
  gtag('config', MEASUREMENT_ID, { send_page_view: false })
}

export function trackPageView(path) {
  if (!MEASUREMENT_ID || typeof window.gtag !== 'function') return
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
  })
}

export function trackEvent(name, params = {}) {
  if (!MEASUREMENT_ID || typeof window.gtag !== 'function') return
  window.gtag('event', name, params)
}
